// extracted by css-extract-rspack-plugin
export default {"cls1":"CitingSourcesCard-cls1_Frj","cls2":"CitingSourcesCard-cls2_429 CitingSourcesCard-cls1_Frj"};